import {
  BaseQueryApi,
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "constants/env";
import * as tags from "constants/tags";
import store from "./store";
import { logout, refreshToken as refreshTokenAction } from "./store-actions";
// import qs from "qs";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: customFetchBaseQuery({
    baseUrl: `${API_BASE_URL}/api/v1`,
    paramsSerializer: (params) => {
      // return qs.stringify(params);
      if (!params) return undefined;

      params = Object.keys(params).reduce((acc, key) => {
        if (typeof params[key] === "undefined") return acc;

        acc[key] =
          typeof params[key] === "object"
            ? JSON.stringify(params[key])
            : params[key];
        return acc;
      }, {});

      return new URLSearchParams(params).toString();
    },
    prepareHeaders(headers, { getState, endpoint }) {
      headers = new Headers(headers);

      const { authUser } = (getState() as any)?.global ?? {};

      const token = authUser?.accessToken;

      // The refresh endpoint authenticates via the refresh token in the body;
      // sending an expired access token here would be rejected by the API, so
      // omit the Authorization header for it.
      if (token && endpoint !== "refreshAuthentication") {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("ngrok-skip-browser-warning", "true");

      return headers;
    },
    fetchFn: async (...arg) => {
      const response = await fetch(...arg);

      if (response.status == 401) {
        // const { refreshToken } = store.getState().global.authUser || {};
        // if (refreshToken) {
        //   try {
        //     return await requestRefreshToken(() => {
        //       return fetch(...arg);
        //     });
        //   } catch (error) {}
        // }

        store.dispatch(logout());
        window.location.reload();
      }

      return response;
    },
  }),
  endpoints: () => ({}),
}).enhanceEndpoints({ addTagTypes: Object.values(tags) });

let isRefreshing = false;
let refreshingFetchPromise: Promise<Response> = null;

function requestRefreshToken(cb) {
  if (isRefreshing) {
    return runCb(cb);
  }
  const { refreshToken } = store.getState().global.authUser || {};

  isRefreshing = true;

  refreshingFetchPromise = fetch(API_BASE_URL + "/account/v1/token-refresh", {
    body: JSON.stringify({ refreshToken }),
  })
    .then(async (response) => {
      if (response.ok) {
        store.dispatch(refreshTokenAction(await response.clone().json()));
      }
      return response;
    })
    .finally(() => {
      isRefreshing = false;
      refreshingFetchPromise = null;
    });

  return runCb(cb);

  function runCb(cb: any) {
    return cb ? refreshingFetchPromise.then(cb) : refreshingFetchPromise;
  }
}

function customFetchBaseQuery({
  prepareArgs = (args) => args,
  ...baseArg
}: CustomFetchBaseQueryOptions) {
  const fetchQuery = fetchBaseQuery(baseArg);

  return (async (args, api, extraOptions) => {
    const newArgs = await prepareArgs(
      ((args) => {
        return {
          ...args,
          headers: args.headers ?? new Headers(baseArg?.headers),
        };
      })(typeof args == "string" ? { url: args } : args),
      api,
      extraOptions
    );
    return await fetchQuery(newArgs, api, extraOptions);
  }) as typeof fetchQuery;
}

type CustomFetchBaseQueryOptions = {
  prepareArgs?: (
    args: FetchArgs,
    api: BaseQueryApi,
    extraOptions: any
  ) => MaybePromise<FetchArgs>;
} & Parameters<typeof fetchBaseQuery>[0];

type MaybePromise<T> = T | PromiseLike<T>;
